export enum FrenchLegalStatus {
  Auto = 'Auto',
  EI = 'EI',
  EURL = 'EURL',
  SARL = 'SARL',
  SAS = 'SAS',
  SASU = 'SASU',
  SA = 'SA',
  SNC = 'SNC',
  SCS = 'SCS',
  SCA = 'SCA',
  SCI = 'SCI',
  SCP = 'SCP',
  SELARL = 'SELARL',
  SELURL = 'SELURL',
  SELAS = 'SELAS',
  SELASU = 'SELASU',
  SELAFA = 'SELAFA',
  SELCA = 'SELCA',
  Association = 'Association',
  Other = 'Other',
}
